module.exports = __webpack_public_path__ + "img/[天啊].00aeb497.svg";